// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationCreditRefusalPath = 'M89.5 8c5.704 0 10.346 4.548 10.496 10.216l.004.284v47c0 5.704-4.548 10.346-10.216 10.496L89.5 76H81v-7h8.5a3.5 3.5 0 003.495-3.308L93 65.5V41H7v24.5a3.5 3.5 0 003.308 3.495L10.5 69H19v7h-8.5C4.796 76 .154 71.452.004 65.784L0 65.5v-47C0 12.796 4.548 8.154 10.216 8.004L10.5 8h79zM93 29v5H7v-5h86zm0-7H7v-3.5l.005-.192A3.5 3.5 0 0110.5 15h79l.192.005A3.5 3.5 0 0193 18.5V22zM50 48c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0 7c9.389 0 17 7.611 17 17s-7.611 17-17 17-17-7.611-17-17 7.611-17 17-17zm3.5 23.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm-7-18.5l1.04 12h4.92l1.04-12h-7z';
var IllustrationCreditRefusal = baseIllustration('IllustrationCreditRefusal', {
  getPath: () => IllustrationCreditRefusalPath
}, 'ColoredIllustrationCreditRefusal');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationCreditRefusal;
//# sourceMappingURL=index.js.map